import toastr from "toastr";

const Mixin = {
    methods: {
        checkIfIsPersian(value) {
            if (!value || value=='null') return true;

            let regex = /^[\u0600-\u06FF\s]+$/;

            return regex.test(value)
        },
        checkIfIsEnglish(value) {
            if (!value || value =='null') return true;

            let regex = /^[a-zA-Z0-9?><;,{}[\]\-_+=!@#$%\^&*|']*$/;

            return regex.test(value)
        },
        checkValidatePhone(string) {
            if (!string || string =='null') return true;

            let regex = /09\d{9}$/;

            return regex.test(string)
        },
        // convert persian digits to english
        toEng(str) {
            let
                persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
                arabicNumbers  = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
            if(typeof str === 'string')
            {
                for(var i=0; i<10; i++)
                {
                    str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
                }
            }
            return str;
        },
        formatLess(price) {
            if (price == null || price === '' ||  price === 0) {
                return 0;
            }

            return price.replace(/,/g, '');
        }
    },
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        },
    }
}

export  {Mixin};
export default {
    install(Vue, option) {
        Vue.mixin(Mixin)
    }
}
